import { CHANGE_BRAND, SET_DIRTY_STATE } from "../constants/actionTypes";
import { createAction } from 'redux-actions';

const changeBrand = createAction(CHANGE_BRAND);

export const setDirtyState = createAction(SET_DIRTY_STATE);


export default changeBrand;

